import * as v from 'valibot';
import { bindingTableSchema } from './BindingTable';
import { neighborsSchema } from './Neighbors';
import { endpointMapSchema } from './Endpoint';
import { ieeeSchema, integerInRange, nwkSchema } from '../../util/valibot';
const zigbeeNodeInputSchema = v.object({
    id: integerInRange(0, 0xffffffff),
    title: v.string(),
    ieee: v.pipe(v.nullish(v.number()), v.transform((x) => x !== null && x !== void 0 ? x : undefined)),
    ieee_hex: v.pipe(v.nullish(ieeeSchema), v.transform((x) => x !== null && x !== void 0 ? x : undefined)),
    last_seen: v.string(),
    manufacturer_code: v.pipe(v.nullish(v.number()), v.transform((x) => x !== null && x !== void 0 ? x : undefined)),
    manufacturer_name: v.pipe(v.nullish(v.string()), v.transform((x) => x !== null && x !== void 0 ? x : undefined)),
    nwk: v.pipe(v.nullish(nwkSchema), v.transform((x) => x !== null && x !== void 0 ? x : undefined)),
    binding_table: v.pipe(v.nullish(bindingTableSchema), v.transform((x) => x !== null && x !== void 0 ? x : undefined)),
    neighbors: v.pipe(v.nullish(neighborsSchema), v.transform((x) => x !== null && x !== void 0 ? x : undefined)),
    endpoints: endpointMapSchema,
    comment: v.string(),
});
export const zigbeeNodeSchema = v.pipe(zigbeeNodeInputSchema, v.transform((o) => ({
    id: o.id,
    title: o.title,
    ieee: o.ieee,
    ieee_hex: o.ieee_hex,
    last_seen: o.last_seen,
    manufacturer_code: o.manufacturer_code,
    manufacturer_name: o.manufacturer_name,
    nwk: o.nwk,
    moved_to_own_slice_binding_table: o.binding_table,
    moved_to_own_slice_neighbors: o.neighbors,
    endpoints: o.endpoints,
    comment: o.comment,
})));
